/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InlineResponse2003ApplicationsStatus from './InlineResponse2003ApplicationsStatus';
import InlineResponse2003OffersModalities from './InlineResponse2003OffersModalities';
import InlineResponse2003OffersStatus from './InlineResponse2003OffersStatus';

/**
 * The InlineResponse2003 model module.
 * @module model/InlineResponse2003
 * @version v1
 */
class InlineResponse2003 {
    /**
     * Constructs a new <code>InlineResponse2003</code>.
     * @alias module:model/InlineResponse2003
     */
    constructor() { 
        
        InlineResponse2003.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse2003</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse2003} obj Optional instance to populate.
     * @return {module:model/InlineResponse2003} The populated <code>InlineResponse2003</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse2003();

            if (data.hasOwnProperty('offers_status')) {
                obj['offers_status'] = InlineResponse2003OffersStatus.constructFromObject(data['offers_status']);
            }
            if (data.hasOwnProperty('offers_modalities')) {
                obj['offers_modalities'] = InlineResponse2003OffersModalities.constructFromObject(data['offers_modalities']);
            }
            if (data.hasOwnProperty('applications_status')) {
                obj['applications_status'] = InlineResponse2003ApplicationsStatus.constructFromObject(data['applications_status']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/InlineResponse2003OffersStatus} offers_status
 */
InlineResponse2003.prototype['offers_status'] = undefined;

/**
 * @member {module:model/InlineResponse2003OffersModalities} offers_modalities
 */
InlineResponse2003.prototype['offers_modalities'] = undefined;

/**
 * @member {module:model/InlineResponse2003ApplicationsStatus} applications_status
 */
InlineResponse2003.prototype['applications_status'] = undefined;






export default InlineResponse2003;

